import React from 'react'

const EditDoctor = () => {
  return (
    <div>EditDoctor</div>
  )
}

export default EditDoctor